import { ListBuilderDimensionExamples } from "../../components/dimensions/ListBuilderDimension";
import type { DimensionTemplates } from "../../types/dimensions";

import {
    DataDimensionValueLogicFirstExample,
    DataDimensionValueLogicFirstRequestExample,
} from "./dataDimension.fixture";
import { dateDimensionExamples } from "./date.dimension.fixture";
import { DropdownDimensionExamples } from "./dropdown.fixture";
import { InputDimensionExamples } from "./input.dimension.fixture";
import { MultiSelectDimensionExamples } from "./multiselect.fixture";
import { staticDropdownDimensionExamples } from "./staticdropdown.dimension.fixture";

import { targetSegmentPickerDimensionExample } from ".";

export interface DimensionFixtureExample {
    id: string;
    name: string;
    description: string;
    dimensions: DimensionTemplates[][];
}

export { targetSegmentPickerDimensionExample } from "./targetSegmentPicker.fixture";

export const DimensionExamples = [
    targetSegmentPickerDimensionExample,
    DataDimensionValueLogicFirstExample,
    DataDimensionValueLogicFirstRequestExample,
    DropdownDimensionExamples.base,
    DropdownDimensionExamples.dependency,
    MultiSelectDimensionExamples.base,
    MultiSelectDimensionExamples.dependency,
    InputDimensionExamples.basic,
    staticDropdownDimensionExamples.basic,
    staticDropdownDimensionExamples.requestParameterMap,
    staticDropdownDimensionExamples.dependency,
    dateDimensionExamples.basic,
    dateDimensionExamples.absolute,
    ListBuilderDimensionExamples.basicExample,
    ListBuilderDimensionExamples.dependencyExample,
    ListBuilderDimensionExamples.cdbInputValidatorExample,
    ListBuilderDimensionExamples.cdbInputValidatorWithDependencyExample,
    ListBuilderDimensionExamples.cdbInputValidatorWithMinMaxExample,
];
